import script from "./updateData.vue?vue&type=script&setup=true&lang=js"
export * from "./updateData.vue?vue&type=script&setup=true&lang=js"

import "./updateData.vue?vue&type=style&index=0&id=7ede7310&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ede7310"]])

export default __exports__